
//Common file type definitions
export const fileTypes = {
  JPG: 'image/jpeg',
  PNG: 'image/png',
  GIF: 'image/gif',
  SVG: 'image/svg+xml',
  MP4: 'video/mp4',
  AVI: 'video/avi',
  TXT: 'text/plain',
  CSV: 'text/csv',
  PDF: 'application/pdf',
  DOC: 'application/msword',
  DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  XLS: 'application/vnd.ms-excel',
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  PPT: 'application/vnd.ms-powerpoint',
  PPTX: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  ZIP: 'application/zip',
  MOV: 'video/quicktime',
  WMV: 'video/x-ms-wmv',
  XMSVIDEO: 'video/x-msvideo', //Some AVI files are detected as this type
}

//Supported image file types
export const imageFileTypes = [
  fileTypes.JPG,
  fileTypes.PNG,
  fileTypes.GIF,
]

//Supported video file types
export const videoFileTypes = [
  fileTypes.MP4,
  fileTypes.MOV,
  fileTypes.AVI,
  fileTypes.WMV,
  fileTypes.XMSVIDEO,
]
